import React from "react";

import { DialogEventProps } from "models/propTypes/dialogPropTypes";

const DialogEvents: React.FC<DialogEventProps> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [key, setKey] = React.useState(0);
  const closeDialog = () => {
    setIsOpen(false);
  };

  const openDialog = () => {
    setKey(key + 1);
    setIsOpen(true);
  };

  return <>{props.render(isOpen, openDialog, closeDialog, key)}</>;
};

export default DialogEvents;
